import React, { useState, useEffect } from 'react'

function Search() {

    const [hi, setHi] = useState([]);

    const coinFound = async () => {
        const url = `https://api.coingecko.com/api/v3/coins/bitcoin`;
        const data = await fetch(url);
        const parsedData = await data.json();
        setHi(parsedData.market_data);
        // console.log(parsedData.market_data)
        console.log(hi);
    }

    useEffect(() => {
        coinFound();

    }, []);


    return (
        <div>
            <p></p>
            <p></p>


        </div>
    )
}

export default Search